import { getLastCorrelationId } from '@platform/client';
import { initBrowserTelemetry } from '@platform/observability/browser';

import { env } from './env';

/**
 * Where Sentry starts for the admin. Imported first by `main.tsx`, and initialised
 * at module load rather than in an effect — an effect runs after the first render,
 * and a crash during that render is the one most worth catching.
 *
 * `__ADMIN_RELEASE__` is stamped in by `vite.config.ts` from the same
 * `resolveRelease()` that writes `dist/version.json`, so the release Sentry groups by
 * and the release the deploy asserts cannot drift apart.
 *
 * The correlation id is read from `@platform/client` at send time (SDK-04), which is
 * what makes a browser error and a server trace resolve to one identifier.
 */
export const telemetryStarted = initBrowserTelemetry({
  dsn: env.VITE_SENTRY_DSN,
  release: __ADMIN_RELEASE__,
  environment: import.meta.env.DEV ? 'development' : 'production',
  getCorrelationId: getLastCorrelationId,
});
